import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const getSalesRepClients = async () => {
    try {
        return axios.get(`${apiUrl}/clients/atc`, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error');
        } else if (error.request) {
            throw new Error('Error al obtener clientes del servidor.');
        } else {
            throw new Error('Ocurrió un error');
        }
    }
};
